import React, { useState, useEffect } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import AssetModalWrapper from './AssetModal.styles';
import { Form, Input, Button, Select, Row, Col, DatePicker, Tabs,Switch } from 'antd';
import { useSelector } from 'react-redux';
import { assetService, activityService } from '@iso/services';
import Loader from '@iso/components/utility/loader';
import SprayForm from './SprayForm';
import AssetHistory from './AssetHistory';
import AddAssetHistoryModal from './AddAssetHistoryModal';
import moment from 'moment';
import _ from "lodash";
import { assetStates } from "@iso/constants/assetStates";
import styled from "styled-components";
import { dateHelper } from '@iso/lib/helpers/dateHelper';
import { assetCategories } from '@iso/constants/assetCategories';
import SensorTab from './SensorTab';
import FormTab from './FormTab';

const { TabPane } = Tabs;
const { Option } = Select;
const dateFormat = "DD/MM/YYYY";

const EditSprayModal = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [assetHistory, setAssetHistory] = useState([]);
  const [visibleHistory, setVisibleHistory] = useState(false);
  const activePermission = useSelector((state) => state.permission.activePermission);
  const [assetData, setAssetData] = useState(null);

  useEffect(() => {
    setAssetData(props.dataAsset);
  }, [props.dataAsset]);

  useEffect(() => {
    if (assetData) {
      if (assetData?.id) {
        updateDataAssetHistory(assetData.id, 'facilities');

        form.resetFields();

        form.setFieldsValue({
          asset: {
            title: assetData.title,
            category: assetData.category,
            description: assetData.description,
            date_of_purchase: assetData.date_of_purchase ? moment(assetData.date_of_purchase) : null,
            manufacture_date: assetData.manufacture_date ? moment(assetData.manufacture_date) : null,
            expiry_date: assetData.expiry_date ? moment(assetData.expiry_date) : null,
            last_checked_date: assetData.last_checked_date ? moment(assetData.last_checked_date) : null,
            state: assetData.state,
            other_state: assetData.other_state,
            primary_object_id: assetData.primary_object_id,
            available_to_contractor: !!assetData.available_to_contractor,
          },
          spray: {
            spray_type: assetData.spray?.spray_type,
            ...assetData.spray?.spray_data
          }
        });
      }
    } else {
      form.resetFields();
    }
  }, [props.propertyId, props.visible, assetData]);

  const updateDataAssetHistory = async (asset_id, modal_type) => {
    try {
      const res = await activityService.getList(asset_id, modal_type);
      if (res.code === '0000') {
        setAssetHistory(res.activities.reverse());
      }
    } catch (error) {
      console.error('Error fetching history:', error);
    }
  };

  const handleSubmit = () => {
    setLoading(true);

    form.validateFields()
      .then(values => onStore(values))
      .catch(info => {
        console.log('Validate Failed:', info);
        setLoading(false);
      });
  };

  const onStore = async (values) => {
    try {
      const data = {
        facility: {
          ...values.asset,
          spray: {
            id: assetData?.spray?.id,
            ...values.spray,
          },
          date_of_purchase: values.asset.date_of_purchase ? dateHelper.dateForAPI(values.asset.date_of_purchase) : '',
          manufacture_date: values.asset.manufacture_date ? dateHelper.dateForAPI(values.asset.manufacture_date) : '',
          property_id: props.propertyId
        }
      };

      const res = await assetService.storeOrUpdate(data, assetData.id);
      
      if (res.code === '0000') {
        props.onSaved(res.facility);
        handleCancel();
        form.resetFields();
      }
    } catch (error) {
      console.error('Error saving spray asset:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    props.onCancel();
  };

  const addHistory = () => {
    setVisibleHistory(true);
  };

  const cancelModalHistory = () => {
    setVisibleHistory(false);
  };

  const renderOptionsAssetState = () => {
    let options = [];
    _.forEach(assetStates, (state, index) => {
      options.push(
        <Option key={index} value={state.value}>
          <ColorItemRow>
            <ColorItemPreview
              style={{ backgroundColor: state.color }}
            ></ColorItemPreview>
            <div>{state.label}</div>
          </ColorItemRow>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a state" allowClear size="large">
        {options}
      </Select>
    );
  };

  const renderOptionObject = (objects) => {
    let options = [];
    _.forEach(objects, (object, index) => {
      options.push(
        <Option key={object.id} value={object.id}>
          {object.name}
        </Option>
      );
    });
    return (
      <Select placeholder="Select an object" allowClear size="large">
        {options}
      </Select>
    );
  };

  const renderOptionsAssetCategory = () => {
    let options = [];
    _.forEach(assetCategories, (cat, index) => {
      options.push(
        <Option key={index} value={cat.value}>
          <div>{cat.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a category"
        allowClear
        size="large"
        disabled
      >
        {options}
      </Select>
    );
  }

  return (
    <AssetModalWrapper
      visible={props.visible}
      onCancel={handleCancel}
      maskClosable={false}
      title={<IntlMessages id="propertyPage.modal.asset.editSprayAsset" />}
      footer={[
        <Button key="back" onClick={handleCancel} className="cancel-button">
          <IntlMessages id="propertyPage.modal.cancel" />
        </Button>,
        <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          <IntlMessages id="propertyPage.modal.save" />
        </Button>,
      ]}
    >
      {modalLoading ? (
        <Loader />
      ) : (
        <Tabs defaultActiveKey="1" className="form-body">
          <TabPane tab={<IntlMessages id="propertyPage.mobModal.detailTab" />} key="1">
          <Form
            form={form}
            layout="vertical"
            scrollToFirstError
          >
            <Form.Item
              name={["asset", "available_to_contractor"]}
              className="isoInputWrapper"
              label="Available to contractors"
              valuePropName="checked"
            >
              <Switch checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>
            <Form.Item
              name={['asset', 'title']}
              className="isoInputWrapper"
              label="Name"
              rules={[
                { required: true, message: 'This field is required', whitespace: true },
                { max: 255, message: 'Name must be at most 255 characters.' },
              ]}
            >
              <Input size="large" placeholder="Enter name" />
            </Form.Item>

            <Form.Item
              name={['asset', 'category']}
              className="isoInputWrapper"
              label="Category"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionsAssetCategory()}
            </Form.Item>

            <Row gutter={[16, 16]}>
            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) => {
                    return prevValues["asset"];
                  }}
                >
                  {({ getFieldValue }) => {
                    return (
                      <Form.Item
                        name={["asset", "state"]}
                        className="isoInputWrapper"
                        label={"State"}
                        rules={
                          getFieldValue("asset")?.type !== "dam"
                            ? [
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]
                            : []
                        }
                      >
                        { renderOptionsAssetState() }
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) => {
                    return prevValues["asset"];
                  }}
                >
                  {({ getFieldValue }) => {
                    return (
                      <Form.Item
                        name={["asset", "date_of_purchase"]}
                        className="isoInputWrapper"
                        label="Date Of Purchase"
                        rules={
                          getFieldValue("asset")?.type !== "dam"
                            ? [
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]
                            : []
                        }
                      >
                        <DatePicker
                          size="large"
                          style={{ width: "100%" }}
                          format={dateFormat}
                        />
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) => {
                    return prevValues["asset"];
                  }}
                >
                  {({ getFieldValue }) => {
                    return (
                      <Form.Item
                        name={["asset", "manufacture_date"]}
                        className="isoInputWrapper"
                        label="Manufacture Date"
                        rules={
                          getFieldValue("asset")?.type !== "dam"
                            ? [
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]
                            : []
                        }
                      >
                        <DatePicker
                          size="large"
                          style={{ width: "100%" }}
                          format={dateFormat}
                        />
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <Form.Item
                  name={["asset", "primary_object_id"]}
                  className="isoInputWrapper"
                  label="Location"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  {renderOptionObject(props.primaryObjects)}
                </Form.Item>
              </Col>
            </Row>

            {/* Spray-Specific Fields */}
            <SprayForm data={assetData?.spray} />

            <Form.Item
              name={['asset', 'description']}
              className="isoInputWrapper"
              label="Description"
              rules={[
                { required: true, message: 'This field is required', whitespace: true },
                { max: 500, message: 'Description must be at most 500 characters.' },
              ]}
            >
              <Input.TextArea size="large" rows={4} placeholder="Enter description" />
            </Form.Item>
          </Form>
          </TabPane>

          <TabPane tab={<IntlMessages id="propertyPage.mobModal.historyTab" />} key="2">
            {(activePermission === "owner" || activePermission === "admin" || activePermission === "modify") && (
              <Button
                className="btn-create-breed"
                type="primary"
                onClick={addHistory}
                style={{ marginBottom: 16 }}
              >
                <IntlMessages id="propertyPage.mobModal.historyTab.addHistory" />
              </Button>
            )}

            <AssetHistory
              assetHistory={assetHistory}
              updateDataAssetHistory={updateDataAssetHistory}
              dataId={assetData?.id}
            />

            <AddAssetHistoryModal
              visibleHistory={visibleHistory}
              cancelModal={cancelModalHistory}
              primaryObjects={props.primaryObjects}
              model="facilities"
              dataId={assetData?.id}
              propertyId={props.propertyId}
              updateDataAssetHistory={updateDataAssetHistory}
            />
          </TabPane>
            {/* Sensor Tab */}
            <TabPane
              tab={<IntlMessages id="propertyPage.mobModal.sensorTab" />}
              key="4"
            >
              <SensorTab assetId={assetData?.id} propertyId={props.propertyId} />
            </TabPane>
            {/* Form Tab */}
            <TabPane
              tab={<IntlMessages id="propertyPage.mobModal.formTab" />}
              key="5"
            >
              <FormTab assetId={assetData?.id} propertyId={props.propertyId} />
            </TabPane>
        </Tabs>
      )}
    </AssetModalWrapper>
  );
};

export default EditSprayModal;

const ColorItemRow = styled.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  div {
    margin: 4px;
  }
`;

const ColorItemPreview = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 2px;
`;